 
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect } from 'react';
import { devModeService } from '../../services/devModeService';

/**
 * Minimal component that only handles F12 key to toggle dev mode
 * No UI rendering - all functionality is in the browser console
 */
export function DevModeToggle() {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // if (e.key === 'F12') {
      //   e.preventDefault();
      //   devModeService.toggleDevMode();
      // }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return null;
}